module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [(_vm.show.delBtn) ? _c('div', {
    staticClass: "del-block"
  }, [_c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_vm._v("刪除帳號")])]) : _vm._e(), _vm._v(" "), (_vm.show.delBtn) ? _c('br') : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioRoleType),
      expression: "radioRoleType"
    }],
    attrs: {
      "type": "radio",
      "name": "roleTypeOption",
      "value": "admin"
    },
    domProps: {
      "checked": _vm._q(_vm.radioRoleType, "admin")
    },
    on: {
      "change": function($event) {
        _vm.radioRoleType = "admin"
      }
    }
  }), _vm._v("系統\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioRoleType),
      expression: "radioRoleType"
    }],
    attrs: {
      "type": "radio",
      "name": "roleTypeOption",
      "value": "brand"
    },
    domProps: {
      "checked": _vm._q(_vm.radioRoleType, "brand")
    },
    on: {
      "change": function($event) {
        _vm.radioRoleType = "brand"
      }
    }
  }), _vm._v("品牌\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioRoleType),
      expression: "radioRoleType"
    }],
    attrs: {
      "type": "radio",
      "name": "roleTypeOption",
      "value": "store"
    },
    domProps: {
      "checked": _vm._q(_vm.radioRoleType, "store")
    },
    on: {
      "change": function($event) {
        _vm.radioRoleType = "store"
      }
    }
  }), _vm._v("店家\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioRoleType),
      expression: "radioRoleType"
    }],
    attrs: {
      "type": "radio",
      "name": "roleTypeOption",
      "value": "pos"
    },
    domProps: {
      "checked": _vm._q(_vm.radioRoleType, "pos")
    },
    on: {
      "change": function($event) {
        _vm.radioRoleType = "pos"
      }
    }
  }), _vm._v("POS\n            ")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.account),
      expression: "content.account"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.content.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "account", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("帳號")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v("\n          " + _vm._s(_vm.info.account) + "\n        ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [(!_vm.info) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("密碼\n      ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        新密碼\n      ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.password),
      expression: "content.password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "password",
      "maxlength": "20",
      "minlength": "6"
    },
    domProps: {
      "value": (_vm.content.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [(!_vm.info) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("密碼確認\n      ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        新密碼確認\n      ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.re_password),
      expression: "content.re_password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "password",
      "maxlength": "20",
      "minlength": "6"
    },
    domProps: {
      "value": (_vm.content.re_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "re_password", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.$v.content.re_password.sameAsPassword) ? _c('span', {
    staticClass: "form-group__message"
  }, [_vm._v("密碼不正確")]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.name),
      expression: "content.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.content.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.radioRoleType === 'brand' || _vm.$route.params.role_type === 'brand') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "品牌綁定",
      "placeholder": "選擇品牌",
      "label": "label",
      "track-by": "value",
      "options": _vm.brandBrief,
      "multiple": true,
      "allow-empty": false
    },
    model: {
      value: (_vm.select.bindingBrandList),
      callback: function($$v) {
        _vm.$set(_vm.select, "bindingBrandList", $$v)
      },
      expression: "select.bindingBrandList"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.radioRoleType === 'store' || _vm.$route.params.role_type === 'store') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandDefault),
      callback: function($$v) {
        _vm.brandDefault = $$v
      },
      expression: "brandDefault"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.radioRoleType === 'store' || _vm.$route.params.role_type === 'store') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "店家綁定",
      "placeholder": "選擇店家",
      "label": "label",
      "track-by": "value",
      "options": _vm.storeBrief,
      "multiple": true,
      "allow-empty": false
    },
    model: {
      value: (_vm.select.bindingStoreList),
      callback: function($$v) {
        _vm.$set(_vm.select, "bindingStoreList", $$v)
      },
      expression: "select.bindingStoreList"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.radioRoleType === 'pos' || _vm.$route.params.role_type === 'pos') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "POS綁定",
      "placeholder": "選擇POS",
      "label": "label",
      "track-by": "value",
      "options": _vm.posBrief,
      "multiple": false,
      "allow-empty": false
    },
    model: {
      value: (_vm.select.bindingPosList),
      callback: function($$v) {
        _vm.$set(_vm.select, "bindingPosList", $$v)
      },
      expression: "select.bindingPosList"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group form-group m-y-0"
  }, [_c('span', {
    staticClass: "input-group-addon form__label"
  }, [_vm._v("\n          手機號碼\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.content.phone),
      expression: "content.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form__input",
    attrs: {
      "placeholder": "",
      "type": "tel",
      "maxlength": "10",
      "id": "phone"
    },
    domProps: {
      "value": (_vm.content.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "phone", $event.target.value.trim())
      }, function($event) {
        return _vm.$v.content.phone.$touch()
      }],
      "keyup": function($event) {
        return _vm.verityPhone()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.content.phone.minLength) ? _c('span', {
    staticClass: "form-group__message"
  }, [_vm._v("手機號碼長度錯誤")]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group form-group m-y-0"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          電子信箱\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.content.email),
      expression: "content.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form__input",
    attrs: {
      "placeholder": "",
      "type": "email",
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.content.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "email", $event.target.value.trim())
      }, function($event) {
        return _vm.$v.content.phone.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.content.email.email) ? _c('span', {
    staticClass: "form-group__message"
  }, [_vm._v("信箱格式錯誤")]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          生日\n        ")]), _vm._v(" "), _c('date-time-picker', {
    staticClass: "form-date-picker w-100-p",
    attrs: {
      "date": _vm.birth,
      "option": _vm.dateoption,
      "limit": _vm.dateLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon b-r"
  }, [_vm._v("\n          性別\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.sex),
      expression: "content.sex"
    }],
    attrs: {
      "type": "radio",
      "name": "sexOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.content.sex, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.content, "sex", "1")
      }
    }
  }), _vm._v("男\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.sex),
      expression: "content.sex"
    }],
    attrs: {
      "type": "radio",
      "name": "sexOption",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.content.sex, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.content, "sex", "2")
      }
    }
  }), _vm._v("\n              女\n            ")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        停權\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.is_suspend),
      expression: "content.is_suspend"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.content, "is_suspend", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("正常")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("停權")])])])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/accountTable"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addAccount
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.upAccount
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon b-r"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("角色\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("帳號\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("名稱\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("品牌綁定\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("品牌\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("店家綁定\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("POS廠ID綁定\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7961dc99"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Account/Temp/AccountFormTemp.vue
// module id = 2489
// module chunks = 1